<template>
	<div class="space-page" v-if="listing">
    <SiteNav></SiteNav>
		<div class="space-page__grid">
			<div class="space-page__container">
        <ListingImages
            v-if="listing.listingImages"
            :iframe_embed="listing.listingGroup.iframeEmbed"
            :space_id="listing.importTitleId"
            :images="listing.listingImages"
            :listing="listing">
        </ListingImages>
				<div class="space-page__columns">
					<div class="space-page__information">
		          <MobileSlider 
		          	v-if="listing.listingImages" 
		          	:images="listing.listingImages" 
		          	:listing="listing"
		            :iframe_embed="listing.listingGroup.iframeEmbed"
            		:space_id="listing.importTitleId">
		          	</MobileSlider>
				      <SpacesHeader :title="listing.title" :address="listing.address" :floor="listing.normalizedFloor" :avatar="listing_group_logo"></SpacesHeader>
		          <SpacesInformation :data="listing.currentUse" :dimensions="listing.dimensions" :categories="listing.categoriesListings" :center="false"></SpacesInformation>
		          <SpacesRequirements v-if="!is_poster"></SpacesRequirements>
		          <!--<SpacesTable v-if="(listing.footfall && listing.footfall[0] && listing.footfall[0] !== '') && !is_poster" :data="['200k - 300k']"></SpacesTable>-->
		          <SpacesTable v-if="listingRates && !is_poster && (!listing.priceOnApplication)" :org_name="user && user.organisation_name ? user.organisation_name : ''" :data="listingRates" :indented="true"></SpacesTable>
		          <SpacesTags v-if="amenities && !is_poster" :data="amenities"></SpacesTags>
		          <SpacesAccordian v-if="!is_poster" :data="faq"></SpacesAccordian>
					</div>
					<div class="space-page__widget">
						<div class="space-page__sticky">
							<EnquiryWidget v-if="!is_poster" :has_yearly="hasYearly" :id="listingId"></EnquiryWidget>
							<MessageWidget :sender="user.id" :receiver="listing.userId" v-if="user && user.response" :id="listingId" :source_type="'single_listing'" :is_poster="is_poster"></MessageWidget>
						</div>
					</div>
				</div>
			    <BasicMap :data="{lat: listing.latitude, lng: listing.longitude}" :title="null"></BasicMap>
			</div>
		</div>
		<SpacesMobileBar :user="user" :receiver="listing.userId" :id="listingId" :listing="listing"></SpacesMobileBar>
	</div>
</template>

<script>
// @ is an alias to /src
import gql from 'graphql-tag'
import axios from 'axios'
import ListingImages from "../../components/search/ListingImages"
import SiteNav from "../../components/global/SiteNav"
import SpacesTable from "../../components/search/SpacesTable"
import SpacesRequirements from "../../components/search/SpacesRequirements"
import SpacesTags from "../../components/search/SpacesTags"
import SpacesAccordian from "../../components/search/SpacesAccordian"
import SpacesInformation from "../../components/search/SpacesInformation"
import SpacesHeader from "../../components/search/SpacesHeader"
import BasicMap from "../../components/search/BasicMap"
import EnquiryWidget from "../../components/search/EnquiryWidget"
import MessageWidget from "../../components/search/MessageWidget"
import SpacesMobileBar from "../../components/search/SpacesMobileBar"
import MobileSlider from "../../components/search/MobileSlider"

export default {
  name: 'Rent',
  data: () => ({
  	user: null,
  	listing: null,
  	faq: null,
  	amenities: null,
  	listing_group_logo: null,
  	footfall: null,
  	listingId: null,
  	hasYearly: null,
  	is_spain: null,
		is_poster: true,
  	listingRates: {
  		title: null,
  		description: null,
  		values: null
  	}
  }),
  components: {
  	ListingImages,
  	SiteNav,
    SpacesTable,
    SpacesRequirements,
    SpacesTags,
    SpacesAccordian,
    SpacesInformation,
    SpacesHeader,
    BasicMap,
    EnquiryWidget,
    MessageWidget,
    SpacesMobileBar,
    MobileSlider
  },
  watch: {
  },
  created () {
  },
  mounted () {
  	this.listingQuery()
  	this.getUser()
  },
  methods: {
     getUser() {
        var self = this
        axios
            .get('/api/searches/get_user')
            .then(response => {
                if (response.data) {
                 	self.user = response.data
                }
            })
    },
    async listingQuery () {
      var self = this
      const response = await this.$apollo.query({
        query: gql`
				query getListing ($slug: String!) {
				  listing(id: "", slug: $slug) {
				    id
				    title
				    address
				    price
				    currentUse
				    dimensions
				    houseRules
				    insuranceAndSafety
				    additionalNotes
				    region
				    county
				    country
				    description
				    latitude
				    longitude
				    liabilityInsurance
				    allowsDiscount
				    insuranceDetail
				    cancellationPolicy
				    capacity
				    floor
				    normalizedFloor
				    spaceSize
				    userId
				    isPoster
				    floorplanImageUrl
				    blueprintImageUrl
				    panoramaImageUrl
				    priceOnApplication
				    importTitleId
				    footfall
						listingRates {
				      edges {
				        node {
				          rateType
				          amount
				          dayOfWeek
				        }
				      }
				    }
				    listingImages {
				      edges {
				        node {
				          id
				          imageUrl
				          isPrimary
				        }
				      }
				    }
				    listingGroup{
				    	title
				    	featuredLogoUrl
				    	iframeEmbed
				    }
            categoriesListings {
              edges {
                node {
                  listingId
                  categoryId
                }
              }
            }
				    amenities {
				      edges {
				        node {
				          title
				        }
				      }
				    }
				  }
				}`,
        variables: {
          slug: self.$route.params.slug
        }
      }).then((response) => {
        var cancel_answer = ""

        self.listing = response.data.listing

        if(self.listing.address.includes('Spain')){
          cancel_answer = self.$store.getters.language.spain_cancel_info
        }else{
          cancel_answer = "Tenants can cancel up to 1 week before for a full refund."
        }

        self.listingId = response.data.listing.id
        self.is_poster = response.data.listing.isPoster
        self.is_spain = self.listing.address.includes('Spain')
        self.listing_group_logo = response.data.listing.listingGroup.featuredLogoUrl

        self.faq = {
            title: self.$store.getters.language.additional_info,
              description: self.$store.getters.language.from_landlord,
              values: [{
            question: self.$store.getters.language.house_rules,
            answer: response.data.listing.houseRules
          }, {
            question: self.$store.getters.language.cancel_policy,
            answer: response.data.listing.cancellationPolicy
          }, {
            question: self.$store.getters.language.insurance_safety,
            answer: response.data.listing.insuranceAndSafety
          }, {
            question: self.$store.getters.language.additional_info,
            answer: response.data.listing.additionalNotes
          }]
        }
        self.amenities = {
            title: self.$store.getters.language.amenities,
            values: response.data.listing.amenities
        }
        self.footfall = {
            title: self.$store.getters.language.footfall,
            values: [{
                name: self.$store.getters.language.weekly_average,
                value: response.data.listing.footfall
            }]
        }

		    var listingRates = []
		    this.listing.listingRates.edges.forEach(function(rate) {
		       var name = null
		       if (rate.node.rateType === 'yearly') {
		        name = 'Yearly'
				self.hasYearly = true
		       }
           else if (rate.node.rateType === 'daily') {
		        name = self.$store.getters.language.daily
		       }
           else if (rate.node.rateType === 'full_month_rate') {
		        name = self.$store.getters.language.monthly
		       }
           // else if (rate.node.rateType === 'full_weekend_rate') {
		       //  name = self.$store.getters.language.weekend
		       // }
           // else if (rate.node.rateType === 'saturday_rate') {
           //   name = self.$store.getters.language.saturday_rate
           // }
           // else if (rate.node.rateType === 'full_fortnight_rate') {
		       //  name = self.$store.getters.language.forthnightly
		       // }
           else if (rate.node.rateType === 'full_week_rate') {
		        name = self.$store.getters.language.weekly
		       }
           // else if (rate.node.dayOfWeek === 'Friday_Saturday') {
		       //  name = self.$store.getters.language.friday + " " + self.$store.getters.language.to + " " + self.$store.getters.language.saturday
           // }

		       if (name) {
			       listingRates.push({
			        name: name,
			        value: `€${parseInt(rate.node.amount).toFixed(0)}`
			       })
		     		}
		    })
		    self.listingRates.title = self.$store.getters.language.pricing_title
		    self.listingRates.description = self.$store.getters.language.quick_glance
		    self.listingRates.exclaimer = self.$store.getters.language.exclaimer
		    self.listingRates.allows_discount = response.data.listing.allowsDiscount
		    self.listingRates.values = listingRates

      }).catch((error) => {
	      console.log(error)
	      self.$router.push({ name: 'PageNotFound' })
      })

    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../../scss/global/includes";

.space-page {
}

.space-page__grid {
	display: flex;
	justify-content: center;
	margin-top: 70px;
	padding: 16px 15px;
	@include breakpoint(tablet-landscape) {
		display: block;
		padding-bottom: 116px;
	}
}

.space-page__container {
	max-width: 1200px;
	width: 100%;
}

.space-page__columns {
	display: grid;
	gap: 16px;
	grid-template-columns: auto 384px;
	position: relative;
	z-index: 1;
	@include breakpoint(tablet-landscape) {
		display: block;
	}

}

.space-page__sticky {
	margin-top: 16px;
  position: sticky;
  top: 80px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding-bottom: 16px;
}

.space-page__information {
	padding: 16px 0;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  @include breakpoint(tablet-landscape) {
      gap: 16px;
      padding: 0 0 16px 0;
  }
}

.space-page__widget {
	@include breakpoint(tablet-landscape) {
		display: none;
	}
}

.space-page .google-map--basic {
	aspect-ratio: 3/1;
	@include breakpoint(tablet-landscape) {
		aspect-ratio: 2/1;
	}
}

</style>
